import { render, staticRenderFns } from "./categories-actions-column-dedicated.vue?vue&type=template&id=22bc79c2"
import script from "./categories-actions-column-dedicated.vue?vue&type=script&lang=js"
export * from "./categories-actions-column-dedicated.vue?vue&type=script&lang=js"
import style0 from "./categories-actions-column-dedicated.vue?vue&type=style&index=0&id=22bc79c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports